
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.34 11.86c0-.64-2.59-3.26-1.87-4 .56-.58 2 .23 2.85-1S4 4.36 4 4c0-1 2.59-.16 4.9-1s2.42-1.38 3.19-1.59S14 2.71 14 3.6a5.91 5.91 0 01-.7 3.2C11.68 9.14 9 10 8.55 10.42c-.71.74-.2.74-.71 1.25S5.93 14 4.73 14s-1.39-1.7-1.39-2.14zm7.07-5.28c-1.55 1.32-2.94 1.26-3.71 2s-.42 1.24-1.13 1.92-1.27.68-1.27 1.38c0 .46-.06 1.2.57 1a6.9 6.9 0 002-1.5c.4-.45.23-.81.91-1.45a6.2 6.2 0 011.76-1 8.74 8.74 0 003-2.65c.61-1.06.82-3.27.28-3.08S12 5.26 10.41 6.58z"}})])
          )
        }
      }
    